/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Safe_1_BodyInputs */

const da_forside_safe_1_body = /** @type {(inputs: Forside_Safe_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI giver et forslag. Karakteren regnes ud fra omsætningstabellen, og intet er endeligt, før du har godkendt det.`)
};

/** @type {(inputs: Forside_Safe_1_BodyInputs) => LocalizedString} */
const en_forside_safe_1_body = da_forside_safe_1_body;

/**

* @param {Forside_Safe_1_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_safe_1_body = /** @type {((inputs?: Forside_Safe_1_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Safe_1_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_safe_1_body(inputs)
	return /** @type {LocalizedString} */ ("AI giver et forslag. Karakteren regnes ud fra omsætningstabellen, og intet er endeligt, før du har godkendt det.")
});